import React from 'react'
import agent from '../agent'
import CommitUserList from './widgets/CommitUserList';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux'
import Pager from 'react-pager'
import {
    BTC_COMMIT_USER_LIST_PAGE_LOADED,
    BTC_COMMIT_USER_LIST_PAGE_UNLOADED
} from '../constants/actionTypes'


const mapStateToProps = state => ({
    ...state.userList,
    appName: state.common.appName,
    token: state.common.token
});

const mapDispatchToProps = dispatch => ({
    onLoad: (payload) => {
        dispatch({ type: BTC_COMMIT_USER_LIST_PAGE_LOADED, payload })
    },
    onUnload: () =>
        dispatch({ type: BTC_COMMIT_USER_LIST_PAGE_UNLOADED }),
});

class Users extends React.Component {
    constructor() {
        super();
    }
    componentWillMount() {
        const payload = agent.Users.getCommitUsers('btc')
        this.props.onLoad(payload);
    }

    componentWillUnmount() {
        this.props.onUnload();
    }
    render() {
        return (
            <div class='pane'>
                <h1>BTC Direct Buying - User</h1>
                <CommitUserList users={this.props.users} loading={this.props.loading} type={'btccommit'}/>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Users);



// WEBPACK FOOTER //
// ./src/components/BtcCommitUsers.js